import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  getPrintingReissueList,
  updateConfig,
} from "../../../store/slices/Printing/printingOldCardReissueSlice";
// import { startTimerRecheck } from "../api";
import { toast } from "react-toastify";

const usePrintingReissue = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [activeCard, setActiveCard] = useState({ id: "", key: "" });
  const [pendingPage, setPendingPage] = useState(1);
  const visitingOneFrontPrintRef = useRef();
  const visitingOneBackPrintRef = useRef();
  const papperFrontPrintRef = useRef();
  const papperBackPrintRef = useRef();
  const bigFrontPrintRef = useRef();
  const vistingDuplexRef = useRef();
  const papperDuplexRef = useRef();
  const foldableCardRef = useRef(null);
  const dispatch = useDispatch();
  const printingState = useSelector((state) => state.printingOldCardReissue);
  const slug = sessionStorage?.getItem("slug");
  const [clickedCardId, setClickedCardId] = useState(null);

  useEffect(() => {
    let params = {
      page: pendingPage,
      per_page: 10,
      process_slug: slug,
      search: printingState.searchReissue,
    };
    dispatch(getPrintingReissueList(params));
    // eslint-disable-next-line
  }, [pendingPage, printingState.currentPageSize]);

  useEffect(() => {
    dispatch(
      getPrintingReissueList({
        page: 1,
        per_page: 10,
        process_slug: slug,
      }),
    );
    dispatch(
      updateConfig((state) => {
        state.searchReissue = "";
        state.showTable = false;
        state.search = "";
      }),
    );
  }, [slug]);

  const handleSearchInput = (e) => {
    const searchValue = e.target.value;
    dispatch(updateConfig((state) => (state.searchReissue = searchValue)));
  };

  const handleSearch = () => {
    const searchValue = printingState?.searchReissue;
    dispatch(
      updateConfig((state) => {
        state.cardReissueData.Pending = [];
      }),
    );
    dispatch(
      getPrintingReissueList({
        search: searchValue,
        page: 1,
        process_slug: slug,
      }),
    );
  };

  // const startTimerPrinting = (item) => {
  //   setClickedCardId(item?._id);
  //   if (!item?._id || clickedCardId === item._id) {
  //     return;
  //   }
  //   let body = {
  //     receipt_id: item?._id,
  //     process_slug: slug,
  //     order_type: 3,
  //   };
  //   startTimerRecheck(body).then((response) => {
  //     if (response?.data?.status_code === 200) {
  //       toast.success("Timer Started");
  //     } else {
  //       toast.error("Can't Start Timer");
  //     }
  //   });
  // };

  const handleCardClick = (e) => {
    setActiveCard({ id: e._id, key: "Pending" });
    // startTimerPrinting(e);
    dispatch(
      updateConfig((state) => {
        state.showTable = true;
        state.showForm = false;
        state.selectedId = [e?._id];
        state.itemTypeId = e?.item_type_id;
        state.gli_id = e?.gli_number;
        state.currentReissuePage = 1;
        state.isMultiPrint = false;
        // state.clear = true;
      }),
    );
    const timmerId = setTimeout(() => {
      dispatch(updateConfig((state) => (state.clear = false)));
      clearTimeout(timmerId);
    }, 100);
  };

  const handleModalClick = () => {
    dispatch(updateConfig((state) => (state.printModal = !state.printModal)));
  };
  const handleLoadMore = (mouseHover) => {
    if (
      mouseHover === "Pending" &&
      printingState?.cardReissueData?.Pending?.length <=
        printingState?.total?.Pending
    ) {
      setPendingPage(pendingPage + 1);
      setIsLoading(false);
    }
  };

  const handleMultiClick = (status = false) => {
    dispatch(
      updateConfig((state) => {
        state.isMultiGliPrint = !state.isMultiGliPrint;
        state.isMultiPrint = status;
      }),
    );
  };

  return {
    visitingOneFrontPrintRef,
    visitingOneBackPrintRef,
    papperFrontPrintRef,
    papperBackPrintRef,
    bigFrontPrintRef,
    vistingDuplexRef,
    foldableCardRef,
    papperDuplexRef,
    cardReissueData: printingState?.cardReissueData,
    totalLength: { Pending: printingState.total.Pending },
    printingState,
    apiStatus: { Pending: printingState?.reissuePendingStatus },
    isLoading,
    activeCard,
    handleSearch,
    handleSearchInput,
    handleMultiClick,
    setIsLoading,
    handleCardClick,
    handleLoadMore,
    handleModalClick,
  };
};

export default usePrintingReissue;
